document.querySelectorAll('.bloc_liens .container_liste, .bloc_pages_enfant .container_liste').forEach(function (container) {
    var liens = container.querySelectorAll('.liens .lien, .enfants .enfant');
    var photos = container.querySelectorAll('.photos .photo');

    function activer(id) {
        photos.forEach(function (photo) {
            photo.classList.toggle('active', photo.id === id);
        });
    }

    liens.forEach(function (lien) {
        var id = lien.getAttribute('data-photo');

        lien.addEventListener('mouseenter', function () {
            activer(id);
        });

        // accessibilité clavier
        lien.addEventListener('focus', function () {
            activer(id);
        });
    });
});